import { FormattedMessage as DefaultFormattedMessage } from 'react-intl';
import { Props } from 'react-intl/src/components/message';

export const IntlFormattedMessage = (props: Props) => {
  return (
    <DefaultFormattedMessage
      values={{
        b: (chunks) => <b>{chunks}</b>,
        br: <br />,
      }}
      {...props}
    />
  );
};
